// React
import React, { useState, useContext } from 'react';

// Styles
import styles from './Wrapper.module.scss';

// Third party
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';

// Material UI
import { Grid, Typography, Button } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

// Services
import { exportData } from '../../../services/data-types';

// Components
import Table from '../Table/Table';
import Filters from '../Filters/Filters';
import ExportFiltersModal from '../ExportFiltersModal/ExportFiltersModal';

// Contexts
import { ListingContext } from '../../../contexts/listing';

// This component
export default function Wrapper(props) {

  // Listing Context
  const { endpoint, pageSize, activeFilters, page, sortModel } = useContext(
    ListingContext
  );

  // Handle export data
  const handleExport = (event) => {
    event.preventDefault();

    const promise = exportData({
      endpoint,
      pageSize,
      page,
      sortModel,
      activeFilters
    });

    trackPromise(
      promise.then((response) => {
      })
    );
  };

  // "Special" filters modal export
  const [exportFiltersModalOpen, setExportFiltersModalOpen] = useState(false);
  const handleExportFiltersModalOpen = (event) => {
    event.preventDefault();
    setExportFiltersModalOpen(true);
  }

  // JSX
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <Grid
          container
          spacing={4}
          alignItems="flex-start"
          justify="space-between">
          <Grid item xs={12} md="auto">
            <Typography variant="h1" component="h1">
              {props.title}
            </Typography>
          </Grid>

          <Grid item xs={12} md="auto">
            <Grid
              container
              spacing={4}
              direction="column"
              justify="center"
              alignItems="center">
              {props.buttonNewLabel !== undefined && props.buttonNewUrl !== undefined && (
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    disableElevation={true}
                    color="primary"
                    component={RouterLink}
                    to={props.buttonNewUrl}>
                    {props.buttonNewLabel}
                  </Button>
                </Grid>
              )}

              {props.exportAction && (
                <Grid item xs={12}>
                  <Button
                    color="primary"
                    onClick={props.exportType === "filters-modal" ? handleExportFiltersModalOpen : handleExport}
                    endIcon={<ChevronRightIcon fontSize="small" />}>
                    {props.buttonExportLabel}
                  </Button>
                </Grid>
              )}

              {props.exportAction && props.exportType === "filters-modal" && (
                <ExportFiltersModal
                  isOpen={exportFiltersModalOpen}
                  onExportFiltersModalClose={() => setExportFiltersModalOpen(false)}/>
              )}
            </Grid>
          </Grid>
        </Grid>
      </div>

      <div className={styles.filters}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Filters />
          </Grid>
        </Grid>
      </div>

      <div className={styles.data}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Table />
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

// Properties
Wrapper.propTypes = {
  title: PropTypes.string.isRequired,
  buttonNewUrl: PropTypes.string,
  buttonNewLabel: PropTypes.string,
  exportAction: PropTypes.bool.isRequired,
  exportType: PropTypes.string,
  buttonExportLabel: PropTypes.string
};
